import React from "react";

import { Box, Flex } from "@chakra-ui/react";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";
import { OcorrenciasTable } from "../../../pages/Criancas/Ocorrencias/Table";

export const Ocorrencia = ({ data, idPJ, user }) => {
  const columns = [
    {
      Header: "Data",
      accessor: "dataOcorrencia",
      Cell: (props) => {
        const custom_date = new Date(props.value).toLocaleDateString("pt-BR");
        return <span>{custom_date}</span>;
      },
    },
    {
      Header: "Tipo da Ocorrência",
      accessor: "tipoOcorrencia",
      sortType: (rowA, rowB, columnId) => {
        const descricaoA = rowA.original.tipoOcorrencia.descricao;
        const descricaoB = rowB.original.tipoOcorrencia.descricao;

        return descricaoA.localeCompare(descricaoB, undefined, {
          sensitivity: "base",
        });
      },
      Cell: (props) => {
        return <span>{props.value?.descricao}</span>;
      },
    },
    {
      Header: "Responsável",
      accessor: "nomeResponsavelOcorrencia",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Descrição/Justificativa",
      accessor: (row) => {
        return row;
      },
      sortType: (rowA, rowB, columnId) => {
        const textA =
          rowA.original.descricaoOcorrencia ||
          rowA.original.justificativaOcorrencia ||
          "";
        const textB =
          rowB.original.descricaoOcorrencia ||
          rowB.original.justificativaOcorrencia ||
          "";

        return textA.localeCompare(textB, undefined, { sensitivity: "base" });
      },
      Cell: (props) => {
        return (
          <span style={{ wordBreak: "break-all" }}>
            {props?.value?.descricaoOcorrencia
              ? props?.value?.descricaoOcorrencia
              : props?.value?.justificativaOcorrencia
              ? props?.value?.justificativaOcorrencia
              : ""}
          </span>
        );
      },
    },
  ];

  return data && data.length > 0 ? (
    <Box className="break-page">
      <Flex>
        <Group
          bgColor="#fff"
          title="Ocorrências"
          mt="15px"
          py="12px"
          mtDivider="5px"
        >
          <OcorrenciasTable
            disableHeaderOptions={true}
            columns={columns}
            data={data}
            entidade={"ocorrencias"}
            id={idPJ}
            user={user}
          />
        </Group>
      </Flex>
    </Box>
  ) : (
    <Box className="break-page">
      <Group
        bgColor="#fff"
        title="Ocorrências"
        mt="15px"
        py="12px"
        mtDivider="5px"
      />
    </Box>
  );
};
